/* ═══════════════════════════════════════════════════════════════
   Threada – mrk-product-customizer.js
   jQuery | Orange popup accent
   v2: + localStorage logo history, existing logo picker, summary step
   ═══════════════════════════════════════════════════════════════ */
(function($) {
  'use strict';
  if (!$) return;

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '£{{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var val = (cents / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, val);
  }

  /* ─── Logo Storage (localStorage) ─── */
  var LOGO_STORAGE_KEY = 'threada_uploaded_logos';

  function saveLogoToStorage(url, name) {
    try {
      var logos = JSON.parse(localStorage.getItem(LOGO_STORAGE_KEY) || '[]');
      if (!logos.find(function(l) { return l.url === url; })) {
        logos.unshift({ url: url, name: name || url.split('/').pop(), date: Date.now() });
        logos = logos.slice(0, 20);
        localStorage.setItem(LOGO_STORAGE_KEY, JSON.stringify(logos));
      }
    } catch(e) { console.warn('Could not save logo to storage:', e); }
  }

  function loadExistingLogos() {
    try {
      var logos = JSON.parse(localStorage.getItem(LOGO_STORAGE_KEY) || '[]');
      var $container = $('[data-mrk-step="3"] [data-logo-form="existing"] .mrk-existing-items');
      $container.empty();

      if (!logos.length) {
        $container.html('<p class="existing-logos__empty">No previously uploaded logos found.<br>Upload a logo first and it will appear here for reuse.</p>');
        return;
      }

      var html = '<p class="existing-logos__hint">Select a previously uploaded logo:</p><div class="existing-logos-grid">';
      logos.forEach(function(logo) {
        html +=
          '<div class="existing-logo-item" data-url="' + logo.url + '" title="' + logo.name + '">' +
            '<div class="existing-logo-item__img"><img src="' + logo.url + '" alt="' + logo.name + '" loading="lazy"></div>' +
            '<div class="existing-logo-item__name">' + logo.name + '</div>' +
            '<div class="existing-logo-item__check">' +
              '<svg width="16" height="16" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="11" fill="#22c55e"/><path d="M6 11l3.5 3.5L16 8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</div>' +
          '</div>';
      });
      html += '</div>';
      $container.html(html);
    } catch(e) { console.warn('Could not load logos from storage:', e); }
  }

  /* ─── State ─── */
  var state = {
    selectedPositions: [],
    assignmentStyle: 'same',
    currentLogoType: null,
    currentPositionName: null,
    selectedExistingUrl: null,   // ← tracks the chosen thumbnail from the grid
    logos: {
      shared: null,
      perPosition: {}
    },
    stepHistory: [],
    swatchPage: 0,
    dispatchInterval: null,
    textLineCounter: 3
  };

  function generateLogoId() {
    return String(Math.floor(100000 + Math.random() * 900000));
  }


  /* ═══════════════════════════════
     COLLAPSE TOGGLES
     ═══════════════════════════════ */
  $(document).on('click', '[data-mrk-collapse]', function(e) {
    e.preventDefault();
    var bodyClass = $(this).attr('data-mrk-collapse');
    $(this).siblings('.' + bodyClass).slideToggle(250);
    $(this).find('.mrk-collapse-chevron').toggleClass('open');
  });


  /* ═══════════════════════════════
     COLOR SWATCHES → filter sizes
     ═══════════════════════════════ */
  $(document).on('change', '.mrk-swatch-radio', function() {
    var val = $(this).val();
    var handleized = $(this).data('name');
    $('.mrk-swatch').removeClass('active');
    $(this).closest('.mrk-swatch').addClass('active');
    $('#mrkColourName').text(val);
    $('#mrkColourDot').css('background-color', $(this).data('color'));
    $('.mrk-variant-row').each(function() {
      $(this).toggle($(this).attr('data-wrap') === handleized);
    });
    $('.mrk-qty-input').val(0);
    updateSizeState();
    var imgSrc = $(this).attr('data-variant-image-id');
    if (imgSrc) {
      var $slide = $('[data-media-src]').filter(function() {
        return $(this).data('media-src').indexOf(imgSrc) > -1;
      });
      if ($slide.length) {
        var gallery = document.querySelector('.product__media-gallery-viewer');
        if (gallery && gallery.swiper) gallery.swiper.slideTo(Number($slide.attr('data-media-index')));
      }
    }
  });

  $(function() {
    var $first = $('.mrk-swatch-radio:checked');
    if ($first.length) $first.trigger('change');
  });


  /* ═══════════════════════════════
     SWATCH CAROUSEL
     ═══════════════════════════════ */
  var PER_PAGE = 8;
  function updateSwatchCarousel() {
    $('#mrkSwatchGrid .mrk-swatch').each(function(i) {
      $(this).toggle(Math.floor(i / PER_PAGE) === state.swatchPage);
    });
    $('.mrk-dot').removeClass('active').filter('[data-page="' + state.swatchPage + '"]').addClass('active');
  }
  $(document).on('click', '#mrkSwatchNext', function() {
    var pages = Math.ceil($('#mrkSwatchGrid .mrk-swatch').length / PER_PAGE);
    if (state.swatchPage < pages - 1) { state.swatchPage++; updateSwatchCarousel(); }
  });
  $(document).on('click', '#mrkSwatchPrev', function() {
    if (state.swatchPage > 0) { state.swatchPage--; updateSwatchCarousel(); }
  });
  $(document).on('click', '.mrk-dot', function() {
    state.swatchPage = parseInt($(this).data('page'), 10);
    updateSwatchCarousel();
  });


  /* ═══════════════════════════════
     QTY +/-
     ═══════════════════════════════ */
  $(document).on('click', '.mrk-qty-btn, [data-action="decrement"], [data-action="increment"]', function(e) {
    e.preventDefault();
    var action = $(this).data('action') || ($(this).hasClass('mrk-qty-plus') ? 'increment' : 'decrement');
    var $input = $(this).siblings('.mrk-qty-input');
    if (!$input.length) $input = $(this).parent().find('.mrk-qty-input');
    var val = parseInt($input.val(), 10) || 0;
    var min = parseInt($input.attr('min'), 10) || 0;
    var max = parseInt($input.attr('max'), 10) || 10000;
    if (action === 'increment' && val < max) $input.val(val + 1).trigger('change');
    if (action === 'decrement' && val > min) $input.val(val - 1).trigger('change');
  });

  function updateSizeState() {
    var anySelected = false, sizes = [];
    var totalQty = 0;

    $('.mrk-qty-input').each(function() {
      var qty = parseInt($(this).val(), 10) || 0;
      if (qty > 0) {
        totalQty += qty;
        anySelected = true;
        var name = $(this).closest('.mrk-variant-row').find('.mrk-v-size-text').text().trim();
        if (name && sizes.indexOf(name) === -1) sizes.push(name);
      }
    });

    // Garment volume discount. For B2B, the tier may carry an explicit per-unit
    // wholesale_price which replaces the retail (base * (1 - discount%)) calc.
    var isB2B = !!window.mrkB2B;
    var vdG = (window.mrkVD && window.mrkVD.garment) || [];
    var garmentTier = totalQty > 0 ? getVolumeTier(vdG, totalQty) : null;
    var garmentLabel = mrkTierDiscountLabel(garmentTier, isB2B);
    var garmentDiscountPct = (garmentLabel && garmentLabel !== 'No Discount') ? (parseFloat(garmentLabel) || 0) : 0;
    var wsUnit = isB2B ? mrkTierWholesaleCents(garmentTier) : null;

    // Sum up the price across all selected qtys
    var price = 0;
    if (wsUnit !== null) {
      price = wsUnit * totalQty;                       // flat wholesale per-unit
    } else {
      $('.mrk-qty-input').each(function() {
        var qty = parseInt($(this).val(), 10) || 0;
        if (qty > 0) {
          var baseUnitCents = parseInt($(this).attr('price'), 10) || 0;
          var discountedCents = Math.round(baseUnitCents * (1 - garmentDiscountPct / 100));
          price += discountedCents * qty;
        }
      });
    }

    if (price === 0) { price = window.base_price; }
    $('.product__block--price .f-price-item--regular').html(FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat));

    // Show discount badge on product page if a tier is active
    if (garmentTier && garmentDiscountPct > 0) {
      var $badge = $('#mrkGarmentDiscountBadge');
      if (!$badge.length) {
        $('.product__block--price .f-price-item--regular').after('<span id="mrkGarmentDiscountBadge" class="mrk-garment-discount-badge"></span>');
        $badge = $('#mrkGarmentDiscountBadge');
      }
      $badge.text(garmentDiscountPct + '% off garments').show();
    } else {
      $('#mrkGarmentDiscountBadge').hide();
    }

    if (anySelected) {
      $('#mrkSizeTick').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="11" fill="#22c55e"/><path d="M6 11l3.5 3.5L16 8" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      $('#mrkSizeLabel').html('Selected Size: <strong>' + sizes.join(', ') + '</strong>');
    } else {
      $('#mrkSizeTick').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><circle cx="11" cy="11" r="10" stroke="#ccc" stroke-width="2" fill="none"/></svg>');
      $('#mrkSizeLabel').text('Select Your Size');
    }
  }
  $(document).on('change input', '.mrk-qty-input', function() { updateSizeState(); });


  /* ═══════════════════════════════
     VOLUME DISCOUNT
     ═══════════════════════════════ */
  $(document).on('click', '.mrk-cvd-tab', function() {
    $(this).siblings('.mrk-cvd-tab').removeClass('active'); $(this).addClass('active');
    var $c = $(this).closest('.mrk-cvd-container');
    $c.find('.mrk-cvd-table-wrap').removeClass('active');
    $c.find('[data-table="' + $(this).data('tab') + '"]').addClass('active');
  });
  $(document).on('click', '.mrk-cvd-toggle', function() {
    $(this).find('.mrk-cvd-toggle-icon').toggleClass('rotated');
    $(this).closest('.mrk-cvd-container').find('.mrk-cvd-content').slideToggle(250);
  });


  /* ═══════════════════════════════
     DISPATCH TIMER
     ═══════════════════════════════ */
  function initDispatchTimer() {
    var $t = $('[data-mrk-dispatch-timer]'); if (!$t.length) return;
    var oNL = parseInt($t.data('offset-no-logo'),10)||1, oEX = parseInt($t.data('offset-express'),10)||3, oST = parseInt($t.data('offset-standard'),10)||8;
    function tick() {
      var now = new Date(), cutoff = new Date(now), ukOff = isUKSummer(now)?1:0;
      cutoff.setUTCHours(14-ukOff,0,0,0);
      var isPast = now >= cutoff, base = new Date(isPast ? now.getTime()+864e5 : now.getTime());
      base.setUTCHours(0,0,0,0);
      var target = isPast ? new Date(cutoff.getTime()+864e5) : cutoff, diff = Math.max(0, target-now);
      $t.find('[data-timer-days]').text(Math.floor(diff/864e5));
      $t.find('[data-timer-hours]').text(Math.floor((diff%864e5)/36e5));
      $t.find('[data-timer-mins]').text(Math.floor((diff%36e5)/6e4));
      $t.find('[data-timer-secs]').text(Math.floor((diff%6e4)/1e3));
      $t.find('[data-date-no-logo]').text(bizDate(base,oNL));
      $t.find('[data-date-express]').text(bizDate(base,oEX));
      $t.find('[data-date-standard]').text(bizDate(base,oST));
    }
    tick(); state.dispatchInterval = setInterval(tick, 1000);
  }
  function bizDate(s,days) { var d=new Date(s),a=0; while(a<days){d.setDate(d.getDate()+1);if(d.getDay()%6)a++;} if(d.getDay()===1){d.setDate(d.getDate()+1);} var dn=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],mn=['January','February','March','April','May','June','July','August','September','October','November','December']; return dn[d.getDay()]+', '+mn[d.getMonth()]+' '+d.getDate(); }
  function isUKSummer(d) { var y=d.getUTCFullYear(),mar=new Date(Date.UTC(y,2,31));mar.setUTCDate(mar.getUTCDate()-mar.getUTCDay());mar.setUTCHours(1,0,0,0);var oct=new Date(Date.UTC(y,9,31));oct.setUTCDate(oct.getUTCDate()-oct.getUTCDay());oct.setUTCHours(1,0,0,0);return d>=mar&&d<oct; }


  /* ═══════════════════════════════
     VALIDATE SIZES
     ═══════════════════════════════ */
  function validateSizes() {
    var has = false;
    $('.mrk-qty-input').each(function() { if (parseInt($(this).val(),10) > 0) has = true; });
    if (!has) { $('.mrk-size-warning').show(); return false; }
    $('.mrk-size-warning').hide(); return true;
  }


  /* ═══════════════════════════════
     GREEN CTA → Opens Popup
     ═══════════════════════════════ */
  $(document).on('click', '.mrk-open-popup', function(e) {
    e.preventDefault();
    if (!validateSizes()) return;

    state.selectedPositions = [];
    state.assignmentStyle = 'same';
    state.currentLogoType = null;
    state.currentPositionName = null;
    state.selectedExistingUrl = null;
    state.logos = { shared: null, perPosition: {} };
    state.stepHistory = [];
    state.textLineCounter = 3;

    $('.mrk-pos-check').prop('checked', false).prop('disabled', false);
    $('.mrk-position-card').removeClass('mrk-pos-locked selected');
    $('.mrk-pos-app').hide();
    $('.mrk-assign-card').removeClass('mrk-assign-card--active');
    $('.mrk-assign-card[data-assign-mode="same"]').addClass('mrk-assign-card--active');
    $('.mrk-same-logo-types').show();
    $('.mrk-per-position-rows').hide().empty();
    $('#mrkCurrentPosLabel').hide();
    resetLogoForms();

    goToStep(0);
    $('.mrk-customizer-overlay').addClass('show');
    $('body').css('overflow', 'hidden');
  });

  $(document).on('click', '.mrk-plain-add', function(e) {
    e.preventDefault(); if (!validateSizes()) return; addPlainToCart();
  });


  /* ═══════════════════════════════
     POPUP NAVIGATION
     ═══════════════════════════════ */
  function goToStep(step, logoType) {
    state.stepHistory.push(step);
    $('.mrk-step').removeClass('active');
    $('[data-mrk-step="' + step + '"]').addClass('active');

    if (logoType !== undefined) {
      state.currentLogoType = logoType;
      $('[data-mrk-step="3"] .mrk-logo-form').hide();
      var formName = getLogoFormName(logoType);
      $('[data-mrk-step="3"] [data-logo-form="' + formName + '"]').show();

      // Auto-load existing logos when that form opens
      if (formName === 'existing') {
        loadExistingLogos();
      }

      if (state.currentPositionName) {
        $('#mrkCurrentPosLabel').text('Position: ' + state.currentPositionName + ' (' + getPositionApp(state.currentPositionName) + ')').show();
      } else {
        $('#mrkCurrentPosLabel').hide();
      }
    }

    $('.mrk-customizer-overlay, .mrk-customizer-popup').scrollTop(0);
  }

  function getLogoFormName(logoType) {
    var type = (logoType || '').toLowerCase();
    if (type.indexOf('text') > -1) return 'text';
    if (type.indexOf('upload') > -1) return 'upload';
    if (type.indexOf('later') > -1) return 'later';
    return 'existing';
  }

  function getPositionApp(posName) {
    for (var i = 0; i < state.selectedPositions.length; i++) {
      if (state.selectedPositions[i].name === posName) return state.selectedPositions[i].application;
    }
    return '';
  }

  function goBack() {
    if (state.stepHistory.length > 1) {
      state.stepHistory.pop();
      var prev = state.stepHistory[state.stepHistory.length - 1];
      $('.mrk-step').removeClass('active');
      $('[data-mrk-step="' + prev + '"]').addClass('active');
    }
  }

  $(document).on('click', '.mrk-popup-close', function(e) { e.preventDefault(); closePopup(); });
  $(document).on('click', '.mrk-customizer-overlay', function(e) { if ($(e.target).hasClass('mrk-customizer-overlay')) closePopup(); });
  $(document).on('keydown', function(e) { if (e.key === 'Escape') closePopup(); });
  function closePopup() { $('.mrk-customizer-overlay').removeClass('show'); $('body').css('overflow', ''); state.stepHistory = []; }


  /* ═══════════════════════════════
     STEP 0: Design Choice
     ═══════════════════════════════ */
  $(document).on('click', '[data-mrk-design-yes]', function() { goToStep(1); });
  $(document).on('click', '[data-mrk-design-no]', function() { closePopup(); addPlainToCart(); });


  /* ═══════════════════════════════
     STEP 1: Position Selection
     ═══════════════════════════════ */
  $(document).on('change', '.mrk-pos-check', function() {
    var $card = $(this).closest('.mrk-position-card');
    if (this.checked) { $card.addClass('selected'); $card.find('.mrk-pos-app').slideDown(200); }
    else { $card.removeClass('selected'); $card.find('.mrk-pos-app').slideUp(200); }
  });

  $(document).on('click', '[data-mrk-step1-next]', function() {
    var positions = [];

    $('[data-mrk-step="1"] .mrk-position-card').each(function() {
      var $cb = $(this).find('.mrk-pos-check');
      if (!$cb.is(':checked')) return;

      var posName = $(this).data('position-name');
      var posId = $(this).data('position-id');
      var app = $('input[name="mrk-application-' + posId + '"]:checked').val() || 'Embroidery';

      positions.push({
        name: posName,
        application: app,
        appMethod: app,
        embroideryVariant: $(this).data('embroidery-variant'),
        printVariant: $(this).data('print-variant'),
        embroideryPrice: parseInt($(this).data('embroidery-price'), 10) || 0,
        printPrice: parseInt($(this).data('print-price'), 10) || 0,
        price: app === 'Embroidery' ? (parseInt($(this).data('embroidery-price'), 10) || 0) : (parseInt($(this).data('print-price'), 10) || 0),
        variantId: app === 'Embroidery' ? $(this).data('embroidery-variant') : $(this).data('print-variant'),
        posImg: $(this).data('position-img') || ''
      });
    });

    if (!positions.length) { alert('Please select at least one position.'); return; }
    state.selectedPositions = positions;
    goToStep(2);
  });


  /* ═══════════════════════════════
     STEP 2: Logo Assignment
     ═══════════════════════════════ */
  $(document).on('click', '.mrk-assign-card', function() {
    var mode = $(this).data('assign-mode');
    state.assignmentStyle = mode;
    $('.mrk-assign-card').removeClass('mrk-assign-card--active');
    $(this).addClass('mrk-assign-card--active');

    if (mode === 'same') {
      $('.mrk-same-logo-types').show();
      $('.mrk-per-position-rows').hide();
    } else {
      $('.mrk-same-logo-types').hide();
      buildPerPositionRows();
      $('.mrk-per-position-rows').show();
    }
  });

  $(document).on('click', '.mrk-logo-type-btn', function() {
    state.currentPositionName = null;
    state.currentLogoType = $(this).data('logo-type');
    resetLogoForms();
    goToStep(3, $(this).data('logo-type'));
  });

  function buildPerPositionRows() {
    var $c = $('.mrk-per-position-rows').empty();

    var logoTypes = [];
    $('.mrk-same-logo-types .mrk-logo-type-btn').each(function() {
      logoTypes.push({
        type: $(this).data('logo-type'),
        imgSrc: $(this).data('img-src') || $(this).find('.mrk-logo-type-circle img').attr('src') || '',
        svgHtml: $(this).find('.mrk-logo-type-circle svg').length ? $(this).find('.mrk-logo-type-circle').html() : '',
        label: $(this).find('.mrk-logo-type-name').text()
      });
    });

    state.selectedPositions.forEach(function(pos) {
      var iconsHtml = '';
      logoTypes.forEach(function(lt) {
        var circleContent = lt.imgSrc
          ? '<img src="' + lt.imgSrc + '" alt="' + lt.label + '">'
          : lt.svgHtml;

        iconsHtml +=
          '<button type="button" class="mrk-per-pos-icon"' +
          ' data-logo-type="' + lt.type + '"' +
          ' data-position="' + pos.name + '">' +
            '<div class="mrk-per-pos-icon__circle">' + circleContent + '</div>' +
            '<div class="mrk-per-pos-icon__label">' + lt.label + '</div>' +
          '</button>';
      });

      var posImgSrc = pos.posImg || $('[data-mrk-step="1"] .mrk-position-card[data-position-name="' + pos.name + '"]').data('position-img') || '';
      var hasDone = !!state.logos.perPosition[pos.name];

      $c.append(
        '<div class="mrk-per-pos-row' + (hasDone ? ' mrk-per-pos-row--done' : '') + '" data-position="' + pos.name + '">' +
          '<div class="mrk-per-pos-row__thumb">' +
            (posImgSrc ? '<img src="' + posImgSrc + '" alt="' + pos.name + '">' : '') +
          '</div>' +
          '<div class="mrk-per-pos-row__info">' +
            '<div class="mrk-per-pos-row__name">' + pos.name + '</div>' +
            '<div class="mrk-per-pos-row__method">' + (pos.appMethod || pos.application) + '</div>' +
          '</div>' +
          (hasDone
            ? '<div class="mrk-per-pos-row__done">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#22c55e"/><path d="M5 10l3.5 3.5L15 7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                ' <span>Done</span>' +
                ' <button type="button" class="mrk-per-pos-edit" data-position="' + pos.name + '">Edit</button>' +
              '</div>'
            : '<div class="mrk-per-pos-row__icons">' + iconsHtml + '</div>') +
        '</div>'
      );
    });

    // When ALL positions done → show "Review Order" button → goes to summary
    var allDone = state.selectedPositions.every(function(p) {
      return !!state.logos.perPosition[p.name];
    });
    if (allDone && state.selectedPositions.length > 0) {
      $c.append('<button type="button" class="mrk-btn mrk-btn-primary mrk-mt-1 mrk-per-pos-review">REVIEW ORDER</button>');
    }
  }

  $(document).on('click', '.mrk-per-pos-icon', function() {
    state.currentPositionName = $(this).data('position');
    state.currentLogoType = $(this).data('logo-type');
    resetLogoForms();
    goToStep(3, $(this).data('logo-type'));
  });

  $(document).on('click', '.mrk-per-pos-edit', function() {
    var posName = $(this).data('position');
    delete state.logos.perPosition[posName];
    buildPerPositionRows();
  });

  // Per-position all-done → summary
  $(document).on('click', '.mrk-per-pos-review', function() {
    buildSummary();
    goToStep(4);
  });

  $(document).on('click', '[data-mrk-back]', function() { goBack(); });


  /* ═══════════════════════════════
     STEP 3: Logo Forms
     ═══════════════════════════════ */
  $(document).on('input', '.mrk-text-line', function() {
    var text = $('.mrk-text-line').map(function() { return $(this).val(); }).get().join('<br>');
    $(this).closest('.mrk-logo-form').find('.bundle-preview-div').html(text || 'Preview');
  });
  $(document).on('change', '.bundle-font-select', function() {
    var f = $(this).val();
    $(this).closest('.mrk-logo-form').find('.bundle-preview-div').css({
      'font-family': f === 'Italic' ? 'inherit' : f,
      'font-style': f === 'Italic' ? 'italic' : 'normal'
    });
  });
  $(document).on('change', '.bundle-color-select', function() {
    $(this).closest('.mrk-logo-form').find('.bundle-preview-div').css('color', $(this).val());
    $(this).closest('.mrk-logo-form').find('.mrk-text-preview').css('background', $(this).find(':selected').data('bg') || '#1a1a1a');
  });

  $(document).on('click', '.mrk-add-line-link', function(e) {
    e.preventDefault();
    var n = state.textLineCounter++;
    $(this).closest('.mrk-logo-form').find('.mrk-extra-text-lines').append(
      '<label class="mrk-form-label">Text Line ' + n + '</label>' +
      '<input type="text" class="mrk-form-input mrk-text-line mrk-extra-text-line bundle-extra-text-line" placeholder="e.g. Additional text" maxlength="100">'
    );
  });

  // Existing logo selection from localStorage grid
  $(document).on('click', '.existing-logo-item', function() {
    $(this).closest('.existing-logos-grid').find('.existing-logo-item').removeClass('existing-logo-item--selected');
    $(this).addClass('existing-logo-item--selected');
    state.selectedExistingUrl = $(this).data('url');
  });

  $(document).on('click', '.mrk-upload-btn-label', function() { $(this).closest('.mrk-upload-zone').find('.mrk-hidden-file-input').click(); });
  $(document).on('change', '.mrk-hidden-file-input', function() { if (this.files[0]) handleFile(this.files[0], $(this).closest('[data-logo-form]')); });
  $(document).on('dragover dragenter', '.mrk-upload-zone', function(e) { e.preventDefault(); $(this).addClass('mrk-drag-over'); });
  $(document).on('dragleave drop', '.mrk-upload-zone', function(e) {
    e.preventDefault(); $(this).removeClass('mrk-drag-over');
    if (e.type === 'drop' && e.originalEvent.dataTransfer.files[0]) handleFile(e.originalEvent.dataTransfer.files[0], $(this).closest('[data-logo-form]'));
  });

  function handleFile(file, $c) {
    var exts = ['.jpg','.jpeg','.png','.svg','.pdf','.eps','.ai'];
    var ext = '.' + file.name.split('.').pop().toLowerCase();
    if (exts.indexOf(ext) === -1) { $c.find('.mrk-upload-error span').text('Invalid file type.'); return; }
    if (file.size > 8388608) { $c.find('.mrk-upload-error span').text('File too large (max 8MB).'); return; }
    $c.find('.mrk-upload-error span').text('');
    $c.find('.mrk-file-name').text(file.name);
    $c.find('.mrk-file-preview').addClass('show');
    $c.find('.mrk-progress-bar').show();
    if (file.type.startsWith('image/')) {
      var r = new FileReader();
      r.onload = function(e) { $c.find('.mrk-thumb-img').attr('src', e.target.result); };
      r.readAsDataURL(file);
    }
    var fd = new FormData(); fd.append('file', file);
    $.ajax({
      url: 'https://threada.xyz', type: 'POST', data: fd, cache: false, contentType: false, processData: false,
      xhr: function() { var x = new XMLHttpRequest(); x.upload.addEventListener('progress', function(e) { if (e.lengthComputable) $c.find('.mrk-progress-fill').css('width', (e.loaded/e.total*100)+'%'); }); return x; },
      success: function(res) {
        var url = res.url || res.filePath || '';
        $c.find('.mrk-input-file-url').val(url);
        $c.find('.mrk-progress-bar').hide();
        // Save to localStorage so it appears in the "Existing Logo" step
        if (url) saveLogoToStorage(url, file.name);
      },
      error: function() {
        var r2 = new FileReader();
        r2.onload = function(e) {
          $c.find('.mrk-input-file-url').val(e.target.result);
          $c.find('.mrk-progress-fill').css('width','100%');
          setTimeout(function(){ $c.find('.mrk-progress-bar').hide(); }, 400);
        };
        r2.readAsDataURL(file);
      }
    });
  }

  $(document).on('click', '.mrk-file-remove', function() {
    var $c = $(this).closest('[data-logo-form]');
    $c.find('.mrk-hidden-file-input, .mrk-input-file-url, .input-file-logo').val('');
    $c.find('.mrk-file-preview').removeClass('show');
  });


  /* ═══════════════════════════════
     SAVE LOGO → goes to summary (step 4) for same mode
                 goes back to assignment for per-position mode
     ═══════════════════════════════ */
  $(document).on('click', '[data-mrk-save-logo]', function() {
    var logoType = state.currentLogoType;
    var posName  = state.currentPositionName;
    var $step    = $(this).closest('.mrk-step');
    var formName = getLogoFormName(logoType);

    var logoData = {
      type:   logoType,
      logoId: generateLogoId()
    };

    if (formName === 'text') {
      var text1 = $step.find('.bundle-text-line-1').val() || '';
      var text2 = $step.find('.bundle-text-line-2').val() || '';
      if (!text1 && !text2) { alert('Please enter at least one text line.'); return; }
      logoData.text = text1;
      if (text2) logoData.text2 = text2;
      var extraLines = [];
      $step.find('.bundle-extra-text-line').each(function() { if ($(this).val()) extraLines.push($(this).val()); });
      if (extraLines.length) logoData.extraLines = extraLines;
      logoData.font  = $step.find('.bundle-font-select').val()  || 'Standard';
      logoData.color = $step.find('.bundle-color-select').val() || 'White';
      var textNotes = $step.find('.bundle-text-notes').val() || '';
      if (textNotes) logoData.notes = textNotes;

    } else if (formName === 'upload') {
      var fileUrl = $step.find('.input-file-logo').val() || $step.find('.mrk-input-file-url').val() || '';
      if (!fileUrl) { alert('Please upload a file.'); return; }
      logoData.file = fileUrl;
      var uploadNotes = $step.find('.bundle-upload-notes').val() || '';
      if (uploadNotes) logoData.notes = uploadNotes;

    } else if (formName === 'later') {
      logoData.sendArtworkLater = true;
      var laterNotes = $step.find('.bundle-later-notes').val() || '';
      if (laterNotes) logoData.notes = laterNotes;

    } else {
      // Existing logo — attach selected URL from grid if available
      logoData.existing = true;
      if (state.selectedExistingUrl) logoData.file = state.selectedExistingUrl;
      var existingNotes = $step.find('.bundle-existing-notes').val() || '';
      if (existingNotes) logoData.notes = existingNotes;
    }

    if (state.assignmentStyle === 'same' || !posName) {
      // SAME mode → save shared logo → show summary
      state.logos.shared = logoData;
      clearCurrentLogoState();
      buildSummary();
      goToStep(4);

    } else {
      // DIFFERENT mode → save this position → back to assignment
      state.logos.perPosition[posName] = logoData;
      clearCurrentLogoState();
      resetLogoForms();

      // Pop step 3 from history
      while (state.stepHistory.length && state.stepHistory[state.stepHistory.length - 1] === 3) {
        state.stepHistory.pop();
      }

      goToStep(2);
      buildPerPositionRows();
      $('.mrk-same-logo-types').hide();
      $('.mrk-per-position-rows').show();
    }
  });
  // Wholesale garment base (cents) for B2B = first garment tier's wholesale_price
  function mrkGarmentWholesaleBaseCents() {
    if (!window.mrkB2B || !window.mrkVD || !window.mrkVD.garment || !window.mrkVD.garment.length) return null;
    return mrkTierWholesaleCents(window.mrkVD.garment[0]);
  }
  function buildVariantRowHtml(v, sizeIndex, count) {
    var sizeValue    = v.selectedOptions[sizeIndex] ? v.selectedOptions[sizeIndex].value : '';
    var price        = parseInt(v.priceV2.amount.replace('.', ''), 10);
    var comparePrice = v.compareAtPriceV2 ? parseInt(v.compareAtPriceV2.amount.replace('.', ''), 10) : null;
    var available    = v.availableForSale;
    var variantImageId = v.image?.src ? v.image.src.split('/files/').pop().split('?')[0] : '';
    var qty = v.quantityAvailable > 0 ? v.quantityAvailable : (available ? 1000 : 0);
    var hasCompare   = comparePrice && comparePrice > price;
    var savePct      = hasCompare ? Math.round((comparePrice - price) / comparePrice * 100) : 0;

    // B2B: replace retail price with the single wholesale garment base
    var wsBaseCents = mrkGarmentWholesaleBaseCents();
    if (wsBaseCents !== null) {
      price = wsBaseCents;
      comparePrice = null;
      hasCompare = false;
      savePct = 0;
    }
    var wrap         = (v.selectedOptions[0] ? v.selectedOptions[0].value : '').toLowerCase().replace(/\s+/g, '-');
    var numericId    = v.id.replace('gid://shopify/ProductVariant/', '');
    return '' +
      '<div class="mrk-variant-row' + (available ? '' : ' mrk-variant-soldout') + '"' +
          ' data-wrap="' + wrap + '"' +
          ' data-size="' + wrap + '"' +
          ' style="display:none;">' +
        '<div class="mrk-variant-inner' + (available ? '' : ' mrk-variant-soldout') + '">' +

          '<div class="mrk-v-name">' +
            '<span class="mrk-v-size-text">' + sizeValue + '</span>' +
            (hasCompare && savePct > 0 ? '<span class="mrk-save-badge">Save ' + savePct + '%</span>' : '') +
          '</div>' +

          '<div class="mrk-v-price">' +
            '<span class="mrk-v-sale-price">' + FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat) + '</span>' +
            (wsBaseCents !== null ? '<span class="mrk-wholesale-badge">Wholesale</span>' :
              (hasCompare ? '<span class="mrk-v-compare-price">' + FoxTheme.Currency.formatMoney(comparePrice, FoxTheme.settings.moneyFormat) + '</span>' : '')) +
          '</div>' +

          '<div class="mrk-v-stock">' +
            (available ? 'In-stock' : 'Sold Out') +
          '</div>' +

          '<div class="mrk-v-qty">' +
            '<input type="hidden" name="items[' + count + '][id]" value="' + numericId + '" data-variant-image-id="' + variantImageId +'">' +
            '<div class="mrk-qty-pill' + (available ? '' : ' mrk-qty-disabled') + '">' +
              '<button type="button" class="mrk-qty-btn mrk-qty-minus" data-action="decrement" aria-label="Decrease"' + (available ? '' : ' disabled') + '><span>−</span></button>' +
              '<input type="number"' +
                ' class="mrk-qty-input mrk-qty-item"' +
                ' name="items[' + count + '][quantity]"' +
                ' value="0" min="0"' +
                ' max="' + (qty || 100) + '"' +
                ' price="' + price + '"' +
                ' data-variant-id="' + numericId + '"' +
                ' data-price="' + price + '"' +
                (available ? '' : ' disabled') + '>' +
              '<button type="button" class="mrk-qty-btn mrk-qty-plus" data-action="increment" aria-label="Increase"' + (available ? '' : ' disabled') + '><span>+</span></button>' +
            '</div>' +
          '</div>' +

        '</div>' +
      '</div>';
  }

  function loadRemainingVariants() {
    var $meta = $('#mrk-variants-meta');
    if (!$meta.length) return;

    var total    = parseInt($meta.data('total'), 10);
    var rendered = parseInt($meta.data('count'), 10);
    if (rendered >= total) return;

    var sizeIndex  = parseInt($meta.data('size-option'), 10);
    var productGid = 'gid://shopify/Product/' + $meta.data('product-id');
    var token      = 'd7733d666740e8bc2d99617a6eb4b4d0';
    var shop       = window.Shopify && window.Shopify.shop;
    var count      = rendered;
    var cursor     = null;
    var page       = 0;

    if (!token || !shop) {
      console.warn('mrk: Storefront token or shop missing.');
      return;
    }

    function fetchPage() {
      var afterArg = cursor ? ', after: "' + cursor + '"' : '';

      var query = 'query {' +
        'product(id: "' + productGid + '") {' +
          'variants(first: 250' + afterArg + ') {' +
            'pageInfo { hasNextPage endCursor }' +
            'edges {' +
              'node {' +
                'id' +
                ' availableForSale' +
                ' quantityAvailable' +
                ' priceV2 { amount }' +
                ' compareAtPriceV2 { amount }' +
                ' selectedOptions { name value }' +
                ' image { id src }' +
              '}' +
            '}' +
          '}' +
        '}' +
      '}';

      $.ajax({
        url: 'https://' + shop + '/api/2026-01/graphql.json',
        type: 'POST',
        contentType: 'application/json',
        headers: { 'X-Shopify-Storefront-Access-Token': token,'Shopify-Storefront-Private-Token': 'Blackpool1' },
        data: JSON.stringify({ query: query }),
        success: function(res) {
          var data = res.data && res.data.product && res.data.product.variants;
          if (!data) { console.warn('mrk: No variant data returned.'); return; }

          // Page 0 = first 250 = already rendered by Liquid, skip
          if (page === 0) {
            page++;
            cursor = data.pageInfo.endCursor;
            if (data.pageInfo.hasNextPage) fetchPage();
            return;
          }

          $.each(data.edges, function(_, edge) {
            $meta.before(buildVariantRowHtml(edge.node, sizeIndex, count));
            count++;
          });

          $meta.data('count', count);

          if (data.pageInfo.hasNextPage) {
            page++;
            cursor = data.pageInfo.endCursor;
            fetchPage();
          } else {
            // All loaded — re-trigger swatch to show/hide correct rows
            var $active = $('.mrk-swatch-radio:checked');
            if ($active.length) $active.trigger('change');
          }
        },
        error: function(xhr) {
          console.warn('mrk: Storefront API error', xhr.responseText);
        }
      });
    }

    fetchPage();
  }
  // Step 4: ADD TO CART button
  $(document).on('click', '[data-mrk-finish-cart]', function() { addCustomToCart(); });

  /* ═══════════════════════════════
     STEP 4: BUILD SUMMARY
     ═══════════════════════════════ */
  function getVolumeTier(tiers, qty) {
    if (!tiers || !tiers.length) return null;
    var match = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      var parts = tiers[i].qty.split('-');
      var min = parseInt(parts[0], 10);
      var max = parts[1] !== undefined
        ? (parts[1] === '' ? Infinity : parseInt(parts[1], 10))
        : Infinity;
      if (qty >= min && qty <= max) { match = tiers[i]; break; }
    }
    return match;
  }

  // For B2B, a tier row may carry an explicit wholesale_price (per-unit, in major
  // currency units e.g. 5.00) and a wholesale_discount label. Returns per-unit cents
  // or null when not configured (caller falls back to the retail path).
  function mrkTierWholesaleCents(tier) {
    if (!tier || tier.wholesale_price === undefined || tier.wholesale_price === null || tier.wholesale_price === '') return null;
    var v = parseFloat(tier.wholesale_price);
    return isNaN(v) ? null : Math.round(v * 100);
  }
  function mrkTierDiscountLabel(tier, isB2B) {
    if (!tier) return 'No Discount';
    if (isB2B && tier.wholesale_discount !== undefined && tier.wholesale_discount !== null && tier.wholesale_discount !== '') {
      return tier.wholesale_discount;
    }
    return tier.discount;
  }

  function buildSummary() {
    var $content = $('.mrk-summary-content');
    $content.empty();

    var totalQty = 0;
    $('.mrk-qty-input').each(function() {
      var qty = parseInt($(this).val(), 10) || 0;
      if (qty > 0) totalQty += qty;
    });

    // B2B: same metafields, but read wholesale_price / wholesale_discount per row.
    var isB2B = !!window.mrkB2B;
    var vdG = (window.mrkVD && window.mrkVD.garment)    || [];
    var vdE = (window.mrkVD && window.mrkVD.embroidery) || [];
    var vdP = (window.mrkVD && window.mrkVD.print)      || [];

    // Garment
    var garmentTier = getVolumeTier(vdG, totalQty);
    var garmentDiscLabel = mrkTierDiscountLabel(garmentTier, isB2B);
    var garmentDiscountPct = (garmentDiscLabel && garmentDiscLabel !== 'No Discount') ? (parseFloat(garmentDiscLabel) || 0) : 0;
    var garmentWsUnit = isB2B ? mrkTierWholesaleCents(garmentTier) : null;

    // Logo — check if EITHER embroidery OR print tier carries a discount at this qty
    var embTier   = getVolumeTier(vdE, totalQty);
    var printTier = getVolumeTier(vdP, totalQty);
    var embLabel   = mrkTierDiscountLabel(embTier, isB2B);
    var printLabel = mrkTierDiscountLabel(printTier, isB2B);
    var embDiscountPct   = (embLabel   && embLabel   !== 'No Discount') ? (parseFloat(embLabel)   || 0) : 0;
    var printDiscountPct = (printLabel && printLabel !== 'No Discount') ? (parseFloat(printLabel) || 0) : 0;
    var hasLogoDiscount  = embDiscountPct > 0 || printDiscountPct > 0;

    var logoCustomizationTotal = 0;

    var tableHtml = '<div class="summary-category"><table class="summary-table">';
    tableHtml += '<thead><tr><th>Position</th><th>Method</th><th>Logo</th><th class="summary-table__price">Price</th></tr></thead><tbody>';

    state.selectedPositions.forEach(function(pos) {
      var logo = state.assignmentStyle === 'same'
        ? state.logos.shared
        : (state.logos.perPosition[pos.name] || null);

      var appMethod = pos.appMethod || pos.application;

      var basePriceEach = appMethod === 'Embroidery' ? pos.embroideryPrice : pos.printPrice;

      var logoTiers = appMethod === 'Embroidery' ? vdE : vdP;
      var logoTier  = getVolumeTier(logoTiers, totalQty);
      var logoLabel = mrkTierDiscountLabel(logoTier, isB2B);
      var logoDiscountPct = (logoLabel && logoLabel !== 'No Discount') ? (parseFloat(logoLabel) || 0) : 0;

      // Both retail and wholesale tiers carry an explicit per-unit price
      // (wholesale_price for B2B, price for retail) — use it directly.
      var lineTotal, priceEach;
      var wsAppUnit = isB2B ? mrkTierWholesaleCents(logoTier) : null;
      if (wsAppUnit !== null) {
        priceEach = wsAppUnit;
        lineTotal = priceEach * totalQty;
      } else {
        var lineBaseTotal = basePriceEach * totalQty;
        var discountCents = Math.round(lineBaseTotal * (logoDiscountPct / 100));
        lineTotal = lineBaseTotal - discountCents;
        priceEach = logoTier && logoTier.price != null ? Math.round(parseFloat(logoTier.price) * 100) : basePriceEach;
      }

      logoCustomizationTotal += lineTotal;

      var logoTypeLabel = logo ? (logo.type || 'Existing Logo') : '—';
      var posImgSrc = pos.posImg || '';

      var logoPreview = '';
      if (logo && logo.sendArtworkLater) {
        logoPreview = '<br><span class="summary-logo-text">Artwork to follow</span>';
      } else if (logo && logo.file) {
        logoPreview = '<br><img class="summary-logo-thumb" src="' + logo.file + '" alt="Logo">';
      } else if (logo && logo.text) {
        logoPreview = '<br><span class="summary-logo-text">' + logo.text + '</span>';
      }

      var priceCell = priceEach === 0
        ? '<span class="summary-free">Free</span>'
        : formatMoney(priceEach) + ' × ' + totalQty + ' = <strong>' + formatMoney(lineTotal) + '</strong>';

      tableHtml +=
        '<tr>' +
          '<td>' +
            (posImgSrc ? '<img class="summary-pos-thumb" src="' + posImgSrc + '" alt="' + pos.name + '">' : '') +
            '<span>' + pos.name + '</span>' +
          '</td>' +
          '<td>' + appMethod + '</td>' +
          '<td>' + logoTypeLabel + logoPreview + '</td>' +
          '<td class="summary-table__price">' + priceCell + '</td>' +
        '</tr>';
    });

    tableHtml += '</tbody></table></div>';

    // Qty breakdown + garment cost (discount % applied to each variant's real price)
    var qtyLines = [];
    var itemTotal = 0;

    $('.mrk-qty-input').each(function() {
      var qty = parseInt($(this).val(), 10) || 0;
      if (qty > 0) {
        var discountedLineCents;
        if (garmentWsUnit !== null) {
          discountedLineCents = garmentWsUnit * qty;          // flat wholesale per-unit
        } else {
          var baseUnitCents = parseInt($(this).attr('price'), 10) || 0;
          var lineTotal = baseUnitCents * qty;
          var discountCents = Math.round(lineTotal * (garmentDiscountPct / 100));
          discountedLineCents = lineTotal - discountCents;
        }
        itemTotal += discountedLineCents;
        var size = $(this).closest('.mrk-variant-row').find('.mrk-v-size-text').text().trim();
        if (size) qtyLines.push(qty + ' × ' + size);
      }
    });

    // Round each total independently — only if its respective discount is active
    if (garmentDiscountPct > 0) {
      itemTotal = Math.ceil(itemTotal / 10) * 10;
    }
    if (hasLogoDiscount) {
      logoCustomizationTotal = Math.ceil(logoCustomizationTotal / 10) * 10;
    }

    var grandTotal = itemTotal + logoCustomizationTotal;

    var totalsHtml = '<div class="summary-totals">';

    if (qtyLines.length) {
      var garmentLabel = 'Items ordered';
      if (garmentDiscountPct > 0) {
        garmentLabel += ' <span class="summary-discount-badge">' + garmentDiscountPct + '% off</span>';
      }
      totalsHtml +=
        '<div class="summary-totals__row">' +
          '<span class="summary-totals__label">' + garmentLabel + '</span>' +
          '<span class="summary-totals__value">' +
            qtyLines.join(', ') + ' (' + totalQty + ' total)' +
            (itemTotal > 0 ? ' — <strong>' + formatMoney(itemTotal) + '</strong>' : '') +
          '</span>' +
        '</div>';
    }

    if (logoCustomizationTotal > 0) {
      totalsHtml +=
        '<div class="summary-totals__row">' +
          '<span class="summary-totals__label">Logo customisation <a href="/pages/customisation-pricing" target="_blank" class="mrk-learn-more">See our pricing</a></span>' +
          '<span class="summary-totals__value">' + formatMoney(logoCustomizationTotal) + '</span>' +
        '</div>';
    }

    totalsHtml +=
      '<div class="summary-totals__row summary-totals__row--grand">' +
        '<span class="summary-totals__label">Total</span>' +
        '<span class="summary-totals__value">' + formatMoney(grandTotal) + '</span>' +
      '</div>' +
    '</div>';

    $content.html(tableHtml + totalsHtml);
  }


  /* ═══════════════════════════════
     RESET HELPERS
     ═══════════════════════════════ */
  function resetLogoForms() {
    $('.bundle-text-line-1, .bundle-text-line-2').val('');
    $('.bundle-preview-div').text('Preview').css({ 'font-family': '', 'font-style': '', 'color': '' });
    $('.mrk-text-preview').css('background', '');
    $('.bundle-font-select').val('Standard');
    $('.bundle-color-select').val('White');
    $('.bundle-text-notes, .bundle-upload-notes, .bundle-existing-notes').val('');
    $('.mrk-hidden-file-input, .mrk-input-file-url, .input-file-logo').val('');
    $('.mrk-file-preview').removeClass('show');
    $('.mrk-extra-text-lines').empty();
    $('.bundle-text-notes, .bundle-upload-notes, .bundle-existing-notes, .bundle-later-notes').val('');
    state.textLineCounter = 3;
    state.selectedExistingUrl = null;
  }

  function clearCurrentLogoState() {
    state.currentPositionName = null;
    state.currentLogoType = null;
    state.selectedExistingUrl = null;
  }


  /* ═══════════════════════════════════════════════════════════════
     ADD TO CART
     ═══════════════════════════════════════════════════════════════ */
  function addPlainToCart() {
    var items = collectSizeItems();
    if (!items.length) items = [{ id: parseInt($('[name="id"]').val(), 10), quantity: 1 }];
    items.forEach(function(it) { it.properties = { '_customization': 'No Logo' }; });
    submitCart({ items: items });
  }

  function addCustomToCart() {
    var sizeItems = collectSizeItems();
    if (!sizeItems.length) sizeItems = [{ id: parseInt($('[name="id"]').val(), 10), quantity: 1 }];

    var productTitle = $('[data-mrk-product-title]').text().trim() || document.title;
    var selectedColor = $('#mrkColourName').text().trim() || '';

    var productsObj = {};
    var productIndex = 1;
    sizeItems.forEach(function(it) {
      var $row = $('.mrk-qty-input[data-variant-id="' + it.id + '"]').closest('.mrk-variant-row');
      productsObj['Product_' + productIndex] = {
        name:     productTitle,
        color:    selectedColor,
        size:     $row.find('.mrk-v-size-text').text().trim() || '',
        quantity: it.quantity,
        sku:      $row.find('[data-sku]').data('sku') || ''
      };
      productIndex++;
    });

    var positionsArr = [];
    state.selectedPositions.forEach(function(pos) {
      var logo = state.assignmentStyle === 'same'
        ? state.logos.shared
        : (state.logos.perPosition[pos.name] || null);

      var posEntry = {
        position:  pos.name,
        appMethod: pos.appMethod || pos.application,
        logoType:  logo ? logo.type : null,
        logoId:    logo ? logo.logoId : null
      };

      if (logo) {
        var lt = (logo.type || '').toLowerCase();
        if (lt.indexOf('text') > -1) {
          posEntry.text  = logo.text  || '';
          if (logo.text2)                                posEntry.text2      = logo.text2;
          if (logo.extraLines && logo.extraLines.length) posEntry.extraLines = logo.extraLines;
          posEntry.font  = logo.font  || '';
          posEntry.color = logo.color || '';
          if (logo.notes) posEntry.notes = logo.notes;
        } else if (lt.indexOf('upload') > -1) {
          if (logo.file)  posEntry.logo  = logo.file;
          if (logo.notes) posEntry.notes = logo.notes;
        } else if (lt.indexOf('later') > -1) {
          posEntry.sendArtworkLater = true;
          if (logo.notes) posEntry.notes = logo.notes;
        } else {
          posEntry.existingLogo = true;
          if (logo.file)  posEntry.logo  = logo.file;
          if (logo.notes) posEntry.notes = logo.notes;
        }
      }

      positionsArr.push(posEntry);
    });

    var productRaw = positionsArr;

    var flatProps = { '_customization': 'Custom Logo' };
    positionsArr.forEach(function(pos) {
      var prefix = '_' + pos.position + ' (' + pos.appMethod + ')';
      flatProps[prefix + ' › Logo Type'] = pos.logoType || 'Existing Logo';
      if (pos.logo)                       flatProps[prefix + ' › Logo'] = pos.logo;
      if (pos.text)                       flatProps[prefix + ' › Text'] = pos.text;
      if (pos.existingLogo && !pos.logo)  flatProps[prefix + ' › Logo'] = 'Existing Logo on File';
      if (pos.sendArtworkLater)           flatProps[prefix + ' › Logo'] = 'Customer will send artwork later';
      if (pos.notes)                      flatProps[prefix + ' › Note'] = pos.notes;
    });

    sizeItems.forEach(function(it) {
      it.properties = $.extend({}, flatProps, { '_product_raw': productRaw });
    });

    var positionLineItems = [];
    sizeItems.forEach(function(mainItem) {
      state.selectedPositions.forEach(function(pos) {
        var logo = state.assignmentStyle === 'same'
          ? state.logos.shared
          : (state.logos.perPosition[pos.name] || null);
        if (!logo) return;

        var isEmbroidery = (pos.appMethod || pos.application) === 'Embroidery';
        var variantId = isEmbroidery ? pos.embroideryVariant : pos.printVariant;
        if (!variantId) return;

        var logoId      = logo.logoId || generateLogoId();
        var lineItemKey = variantId + '_' + logoId + '_' + pos.name.replace(/\s+/g, '_');

        var posProps = {
          '_ParentVariant':  mainItem.id,
          '_time':           new Date().toISOString(),
          '_qty':            mainItem.quantity,
          '_lineItemKey':    lineItemKey,
          '_BundleItemName': productTitle,
          '_logoId':         logoId,
          'Application Method': pos.appMethod || pos.application,
          'Logo Type':       logo.type || 'Existing Logo',
          'Position':        pos.name
        };

        var lt = (logo.type || '').toLowerCase();
        if (lt.indexOf('text') > -1) {
          posProps['Logo Text']  = logo.text  || '';
          if (logo.text2) posProps['Logo Text 2'] = logo.text2;
          if (logo.extraLines && logo.extraLines.length) {
            logo.extraLines.forEach(function(line, i) { posProps['Logo Text ' + (i + 3)] = line; });
          }
          posProps['Logo Font']  = logo.font  || '';
          posProps['Logo Color'] = logo.color || '';
          if (logo.notes) posProps['Note'] = logo.notes;
        } else if (lt.indexOf('upload') > -1) {
          if (logo.file)  posProps['Logo'] = logo.file;
          if (logo.notes) posProps['Note'] = logo.notes;
        } else if (lt.indexOf('later') > -1) {
          posProps['Logo'] = 'Customer will send artwork later';
          if (logo.notes) posProps['Note'] = logo.notes;
        } else {
          if (logo.file)  posProps['Logo'] = logo.file;
          if (logo.notes) posProps['Note'] = logo.notes;
        }

        positionLineItems.push({ id: parseInt(variantId, 10), quantity: mainItem.quantity, properties: posProps, parent_id: mainItem.id });
      });
    });

    submitCart({ items: positionLineItems.concat(sizeItems) });
  }

  function collectSizeItems() {
    var items = [];
    $('.mrk-qty-input').each(function() {
      var qty = parseInt($(this).val(), 10), vid = parseInt($(this).data('variant-id'), 10);
      if (qty > 0 && vid) items.push({ id: vid, quantity: qty });
    });
    return items;
  }

  function submitCart(data) {
    showLoader();
    $.ajax({
      url: '/cart/add.js', type: 'POST', contentType: 'application/json', data: JSON.stringify(data),
      success: function() { hideLoader(); closePopup(); window.location.href = '/cart'; },
      error: function(xhr) { hideLoader(); var m = 'Error adding to cart.'; try { m = JSON.parse(xhr.responseText).description || m; } catch(e) {} alert(m); }
    });
  }

  function showLoader() { $('.mrk-loader-overlay').addClass('show'); }
  function hideLoader() { $('.mrk-loader-overlay').removeClass('show'); }


  /* ═══════════════════════════════
     CUSTOM ELEMENT
     ═══════════════════════════════ */
  if (!customElements.get('product-form-mrk')) {
    customElements.define('product-form-mrk', class extends HTMLElement {
      constructor() { super(); var f = this.querySelector('form'); if (f) f.addEventListener('submit', function(e) { e.preventDefault(); }); }
    });
  }


  /* ═══════════════════════════════
     INIT
     ═══════════════════════════════ */
  $(function() {
    initDispatchTimer();
    loadRemainingVariants();
    updateSizeState();
    if ($('#mrkSwatchGrid .mrk-swatch').length > PER_PAGE) updateSwatchCarousel();
  });
  /* ═══════════════════════════════
   USP MODALS
   ═══════════════════════════════ */
  function openModal(id) {
    $('#modal-' + id).addClass('show');
    $('body').css('overflow', 'hidden');
    setTimeout(function() {
      $('#modal-' + id).find('.mrk-modal-close').focus();
    }, 50);
  }

  function closeModal($overlay) {
    $overlay.removeClass('show');
    if (!$('.mrk-customizer-overlay').hasClass('show')) {
      $('body').css('overflow', '');
    }
  }

  // Open via data-modal link
  $(document).on('click', '[data-modal]', function(e) {
    e.preventDefault();
    openModal($(this).data('modal'));
  });

  // Close via X button or "Got It"
  $(document).on('click', '.mrk-modal-close, [data-modal-close]', function() {
    closeModal($(this).closest('.mrk-modal-overlay'));
  });

  // Close by clicking the backdrop
  $(document).on('click', '.mrk-modal-overlay', function(e) {
    if ($(e.target).hasClass('mrk-modal-overlay')) {
      closeModal($(this));
    }
  });

  // Close on Escape
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      var $open = $('.mrk-modal-overlay.show');
      if ($open.length) closeModal($open);
    }
  });
})(window.jQuery);